import { useEffect, useState } from "react";

const ExpiryDateTimer =({dashboardCard1Object,item})=>{
    
     const [timeLeft, setTimeLeft] = useState({
        days: 0, hours: 0, mins: 0, secs: 0,
      });
     function getExpiryDateFromValidity(
      validityJson
    ) {
      if (!validityJson) return null;
    
      const data =
        typeof validityJson === "string"
          ? JSON.parse(validityJson)
          : validityJson;
    
      if (!data || !data.validityCount || !data.durationType) return null;
    
      const count = parseInt(data.validityCount, 10);
      const type = data.durationType.toLowerCase();
    
      // Date-only (midnight)
      const date = new Date();
      date.setHours(0, 0, 0, 0);
    
      switch (type) {
        case "days":
          date.setDate(date.getDate() + count);
          break;
    
        case "weeks":
          date.setDate(date.getDate() + count * 7);
          break;
    
        case "months":
          date.setMonth(date.getMonth() + count);
          break;
    
        case "years":
          date.setFullYear(date.getFullYear() + count);
          break;
    
        default:
          return null;
      }
    
      return formatDate(date);
    }
    function formatDate(date) {
      return date.toISOString().split("T")[0]; // YYYY-MM-DD
    }
    function formatDateTime(dateStr) {
  const date = new Date(dateStr.replace(" ", "T"));

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
}
useEffect(() => {
    const timer = setInterval(() => {
      const diff = new Date(item?.expiry_date) - new Date();
      if (diff <= 0) return clearInterval(timer);

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        mins: Math.floor((diff / (1000 * 60)) % 60),
        secs: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [item?.expiry_date]);
    return(<>
    <div><span className="producttimertag" style={{display:"flex",justifyContent:"left",gap:"5px"}}>Enrolled On: {formatDateTime(item?.enrollment_date)}</span></div>
    {timeLeft.days?
<span className="producttimertag" style={{display:"flex",justifyContent:"left",gap:"5px"}}>Expiring In: 
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}} ><span>{timeLeft.days}</span><span>Day</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.hours}</span><span>Hr</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.mins}</span><span>Min</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.secs}</span><span>Sec</span></div>
          </span>
:parseInt(item?.has_lifetime_access)?<span className="producttimertagTwo" style={{display:"flex",justifyContent:"left",gap:"5px"}}>Lifetime Accessible</span>:"" }
<style>{`


.producttimertag{ margin:10px;
   padding: 6px 10px;
  border-radius: 5px;color:#222222;
  font-size: 14px; 
 border:2px solid #ffffff;
 background:#f1f1f1;
}
.producttimertagTwo{ margin:10px;
   padding: 6px 10px;
  border-radius: 5px;color:#222222;
  font-size: 14px; 
 border:2px solid rgba(127, 252, 175, 1);
 background:rgba(127, 252, 175, 1);
}`}</style>
</>)
}
export default ExpiryDateTimer